<template>
  <div class="discounts">

    <div class="title-button">

      <h1>Discounts</h1>

      <router-link to="/discounts/create" class="button p-3" v-if="userRole == 1">New discount</router-link>
      <!-- <router-link to="/discounts/create" class="button">Tour Type Discount</router-link> -->

    </div>

    <div class="box">

      <form @submit.stop.prevent="doSearch" class="box__header">
        <!-- <input v-model="quickSearch" type="search" placeholder="Quick search">
        <button class="button button--small" type="submit">Search</button>
        <input v-model="quickSearch" type="search" placeholder="Quick search"> -->
        
        <div class="row">
          <div class="col-md-2">
            <div><input type="text" placeholder="Discount Code" v-model="quickSearch.search_by_code" style="width: 100%; margin-top: 2px;"></div>
          </div>
          <div class="col-md-4">
            <v-select
              label="name"
              :options="this.availableTours"
              id="tours"
              index="id"
              v-model="quickSearch.search_by_tour"
              placeholder="Select Tour(s)"
            />
          </div>
          <div class="col-md-4">
            <button class="button" type="submit" style="margin-top:5px">Filter results</button>
          </div>
        </div>
      </form>
      <hr>
      <vdtnet-table
        ref="table"
        :fields="fields"
        :opts="options"
        @edit="editDiscount"
        @delete="deleteDiscount"
        :key="tableKey"
        >
      </vdtnet-table>

    </div><!-- box -->

  </div>
</template>

<script>
import 'datatables.net'
import VdtnetTable from 'vue-datatables-net'
import axios from 'axios';
// import moment from 'moment'
export default {
  name: 'discounts',
  components: {
    VdtnetTable
  },
  computed : {
    userRole() {
      return localStorage.getItem("user_role");
    },
  },
  created () {
    this.getTours()
  },
  data() {
    return {
      options: {
        ajax: {
          url: this.$api + 'discounts/table2',
          headers: {
            'Accept': 'application/json',
            'Authorization': localStorage.getItem('token')
          }
        },
        responsive: false,
        processing: true,
        searching: true,
        searchDelay: 1500,
        destroy: true,
        ordering: true,
        lengthChange: true,
        serverSide: true,
        dom: 'rtlip',
        autoWidth: false,
        lengthMenu: [ [25, 50, 100, 500], [25, 50, 100, 500] ],
        pageLength: 25,
      },
      fields: {
        code: {
          label: 'Discount code'
        },
        description: {
          label: 'Description'
        },
        value: {
          label: 'Value',
          render: (data, type, row) => {
            if (row.penalty_type == 0) {
              return `£${ data }`
            } else {
              return `${ data }%`
            }
          }
        },
        tour_name: {
          label: 'Tour Name',
          name: 'tour2.name',
          render: (data) => {
            // return data 
            if(data)
            {
              return data
            }else
            {
              return "N/A Legacy discount"
            }
          }
        },

        edit: {
          searchable: false,
          sortable: false,
          label: ' ',
          className: 'table-action',
          render: (data, type, row) => {
            return `<a href="/discounts/edit/${ row.id }" data-action="edit" class="icon icon--more">Edit</a>`
          }
        },
        delete: {
          searchable: false,
          sortable: false,
          label: ' ',
          className: 'table-action',
          render: (data, type, row) => {
            if (this.userRole == 1) {
              return `<a href="/discounts/${ row.id }/delete" data-action="delete" class="icon icon--delete">Delete</a>`
            } else {
              return ''
            }

          }
        }
      },
      tableKey:0,
      availableTours:[],
      quickSearch: {
        search_by_code : null,
        search_by_tour : null
      }
    }
  },
  methods: {
    doSearch() {

      // this.$refs.table.search(this.quickSearch)
      const ajaxUrl = this.$api + 'discounts/table2'

      const queryString = new URLSearchParams();

      if(this.quickSearch.search_by_code) {
        queryString.set('search_by_code', this.quickSearch.search_by_code);
      }

      if(this.quickSearch.search_by_tour){
        queryString.set('search_by_tour', this.quickSearch.search_by_tour);
      }

      const urlWithParams = `${ajaxUrl}?${queryString.toString()}`;

      // Update the datatable's AJAX URL with the Start Date & End Date query parameters
      this.options.ajax.url = urlWithParams;

      // Increment the tableKey to force re-render and fetch new data
      this.tableKey++;
    },
    editDiscount(data) {
      this.$router.push({ name: 'discount-edit', params: { id: data.id }})
    },
    deleteDiscount(data) {
      this.$store.dispatch('setLoadStatus')
      fetch(this.$api + 'discounts/' + data.id + '/delete', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(response => {
        this.errors = response.errors
        if(response.success == true) {
          this.$refs.table.reload()
          this.$notify({
            type: 'success',
            title: response.message
          });
        } else if (response.errors) {
          this.$notify({
            type: 'error',
            title: response.message
          });
        } else {
          this.$notify({
            type: 'error',
            title: response.Error
          });
        }
        this.$store.dispatch('setLoadStatus')
      });
    },
    getTours()
    {
      axios.get(this.$api + 'tours')
      .then((response) => {
        this.availableTours = response.data.data
      });
    },
  },
  
}

</script>
